import { useEffect, useState } from 'react'

import useWindowSize from './useWindowSize'

interface UseDeviceWidth {
    isMobile: boolean;
    isTabletPortrait: boolean;
    isTabletLandscape: boolean;
    isDesktop: boolean;
}

const useDeviceWidth = (): UseDeviceWidth => {
    const { width } = useWindowSize()

    const [isMobile, setIsMobile] = useState<boolean>(false)
    const [isTabletPortrait, setIsTabletPortrait] = useState<boolean>(false)
    const [isTabletLandscape, setIsTableLandscape] = useState<boolean>(false)
    const [isDesktop, setIsDesktop] = useState<boolean>(false)

    const deviceMinWidths: Record<string, number> = {
        mobile: 0,
        tabletPortrait: 768,
        tabletLandscape: 1024,
        desktop: 1448,
    }

    useEffect((): void => {
        if (! width) {
            return
        }

        setIsMobile(width < deviceMinWidths.tabletPortrait)
        setIsTabletPortrait(width >= deviceMinWidths.tabletPortrait && width < deviceMinWidths.tabletLandscape)
        setIsTableLandscape(width >= deviceMinWidths.tabletLandscape && width < deviceMinWidths.desktop)
        setIsDesktop(width >= deviceMinWidths.desktop)
    }, [width])

    return {
        isMobile,
        isTabletPortrait,
        isTabletLandscape,
        isDesktop,
    }
}

export default useDeviceWidth
